import { render } from "./WhatsNew.vue?vue&type=template&id=5f3fcbc4&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"

import "./WhatsNew.vue?vue&type=style&index=0&id=5f3fcbc4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3fcbc4"]])

export default __exports__